<app-alert
	[title]="dataVoucher.messageSuccess.message.title"
	[message]="dataVoucher.messageSuccess.message.subTitle"
	[extraContent]="dataVoucher.messageSuccess.extraContent"
	[showCloseButton]="true"
	type="succes"
></app-alert>
<div class="comprobante_content" [ngClass]="classOperations">
	<div class="comprobante_top clearfix">
		<span class="left_codigo" *ngIf="dataVoucher.operacion">
			<h5>{{ dataVoucher.operacion.title }}</h5>
			<p *ngIf="dataVoucher.operacion.subTitle">
				<strong>{{ dataVoucher.operacion.subTitle }}</strong>
			</p>
		</span>

		<span
			[ngClass]="{
				date_comprobante: dataVoucher.onlyDate === false || dataVoucher.onlyDate === undefined,
				'not-operationcode': !dataVoucher.operacion,
				right_codigo: dataVoucher.operacion
			}"
		>
			<ng-container *ngFor="let item of dataVoucher.dates">
				<h5>{{ item.title }}</h5>
				<p *ngIf="item.subTitle">{{ item.subTitle }}</p>
			</ng-container>
		</span>
	</div>

	<div class="body_comprobante">
		<ul>
			<li *ngFor="let item of dataVoucher.detail">
				<h5>{{ item.title }}</h5>
				<p [innerHtml]="item.subTitle"></p>
			</li>
		</ul>
	</div>

	<app-alert
		[title]="dataVoucher.messageInfo.title"
		[message]="dataVoucher.messageInfo.subTitle"
		type="info"
	></app-alert>

	<div class="bottom_comprobante">
		<a class="btn_print_comprobante" (click)="clickPrint()">Imprimir Comprobante</a>
		<a class="btn_pdf_comprobante" (click)="clickSavePdf()">Guardar en PDF</a>
		<a *ngIf="showSendEmailOption" class="btn_email_comprobante" (click)="clickShowSendEmail()">Enviar por Email</a>
	</div>

	<ng-container *ngIf="showSendEmail">
		<div class="content body_comprobante" [formGroup]="formGroup">
			<h2>Enviar constancia por Email</h2>
			<div class="email">
				<input class="form_element" type="text" formControlName="email" />
				<button [disabled]="formGroup.invalid" type="button" (click)="clickSendEmail()">Enviar</button>
			</div>
			<app-valid-message-form
				*ngIf="emailField.hasError('required')"
				message="Ingrese su Email"
				type="warning"
			></app-valid-message-form>
			<app-valid-message-form
				*ngIf="emailField.hasError('email')"
				message="Ingrese un email valido"
				type="error"
			></app-valid-message-form>
		</div>
	</ng-container>
</div>
